import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/leads/templates/new")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads/templates/new", search, replace: true });
    },
});
